// import React, { useEffect, useState } from "react";
// import { FaCheckCircle, FaTimesCircle, FaTrash } from "react-icons/fa";

// const GroupInfo = () => {
//   const [groupInfo, setGroupInfo] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const payload = {
//     groupId: "Y2FwaV9ncm91cDo5MTg5MTkxNzE5ODU6MTIwMzYzNDA0NTQyMTcwODAy"
//   };

//   useEffect(() => {
//     const fetchGroupInfo = async () => {
//       try {
//         const response = await fetch(
//           "https://emedha.com/echatbot/enotifier/groups/getGroupInfo.php",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(payload),
//           }
//         );

//         const data = await response.json();
//         setGroupInfo(data);
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching group info:", err);
//         setLoading(false);
//       }
//     };

//     fetchGroupInfo();
//   }, []);

//   if (loading) return <p>Loading...</p>;

//   const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "30px auto",
//     padding: "20px",
//     borderRadius: "14px",
//     background: "#ffffff",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//     fontFamily: "sans-serif",
//   },
//   title: {
//     marginBottom: "5px",
//     color: "#0158a2",
//   },
//   desc: {
//     color: "#555",
//     marginBottom: "20px",
//   },
//   subTitle: {
//     marginBottom: "12px",
//     color: "#333",
//   },
//   list: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "12px",
//   },
//   card: {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "12px 16px",
//     background: "#f6f9fc",
//     borderRadius: "12px",
//     alignItems: "center",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   },
//   number: {
//     fontSize: "16px",
//     fontWeight: "600",
//   },
//   iconRow: {
//     display: "flex",
//     gap: "12px",
//   },
//   iconGreen: {
//     color: "#2ecc71",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
//   iconRed: {
//     color: "#e74c3c",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
//   iconDelete: {
//     color: "#444",
//     fontSize: "20px",
//     cursor: "pointer",
//   },
// };


//   return (
//     <div style={styles.container}>
//       {/* GROUP HEADER */}
//       <h2 style={styles.title}>{groupInfo.subject}</h2>
//       <p style={styles.desc}>{groupInfo.description}</p>

//       {/* PARTICIPANTS LIST */}
//       <h3 style={styles.subTitle}>Participants</h3>

//       <div style={styles.list}>
//         {groupInfo.participants?.map((p, index) => (
//           <div key={index} style={styles.card}>
//             <span style={styles.number}>{p.wa_id}</span>

//             <div style={styles.iconRow}>
//               <FaCheckCircle style={styles.iconGreen} title="Approve" />
//               <FaTimesCircle style={styles.iconRed} title="Reject" />
//               <FaTrash style={styles.iconDelete} title="Remove" />
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GroupInfo;


// import React, { useEffect, useState } from "react";
// import { FaCheckCircle, FaTimesCircle, FaTrash } from "react-icons/fa";

// const GroupInfo = () => {
//   const [groupInfo, setGroupInfo] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const payload = {
//     groupId: "Y2FwaV9ncm91cDo5MTg5MTkxNzE5ODU6MTIwMzYzNDA0NTQyMTcwODAy"
//   };

//   useEffect(() => {
//     const fetchGroupInfo = async () => {
//       try {
//         const response = await fetch(
//           "https://emedha.com/echatbot/enotifier/groups/getGroupInfo.php",
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(payload), // <-- EXACTLY LIKE POSTMAN
//           }
//         );

//         const data = await response.json();
//         setGroupInfo(data);
//       } catch (error) {
//         console.error("Error:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchGroupInfo();
//   }, []);

//   if (loading) return <p>Loading...</p>;
//   if (!groupInfo) return <p>No data found</p>;

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.title}>{groupInfo.subject}</h2>
//       <p style={styles.description}>{groupInfo.description}</p>

//       <h3 style={styles.subTitle}>Participants</h3>

//       {groupInfo.participants?.map((user, index) => (
//         <div key={index} style={styles.card}>
//           <span style={styles.number}>{user.wa_id}</span>

//           <div style={styles.iconRow}>
//             <FaCheckCircle style={styles.iconGreen} title="Approve" />
//             <FaTimesCircle style={styles.iconRed} title="Reject" />
//             <FaTrash style={styles.iconDelete} title="Remove" />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default GroupInfo;

// const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "20px auto",
//     padding: "20px",
//     borderRadius: "14px",
//     background: "#fff",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//     fontFamily: "Poppins, sans-serif",
//   },
//   title: {
//     color: "#0158a2",
//     marginBottom: "6px",
//   },
//   description: {
//     color: "#444",
//     marginBottom: "20px",
//   },
//   subTitle: {
//     color: "#222",
//     marginBottom: "12px",
//   },
//   card: {
//     display: "flex",
//     justifyContent: "space-between",
//     background: "#f2f7ff",
//     padding: "12px 16px",
//     marginBottom: "10px",
//     borderRadius: "12px",
//     alignItems: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
//   },
//   number: {
//     fontWeight: "600",
//     fontSize: "16px",
//   },
//   iconRow: {
//     display: "flex",
//     gap: "14px",
//   },
//   iconGreen: {
//     color: "#2ecc71",
//     cursor: "pointer",
//     fontSize: "22px",
//   },
//   iconRed: {
//     color: "#e74c3c",
//     cursor: "pointer",
//     fontSize: "22px",
//   },
//   iconDelete: {
//     color: "#555",
//     cursor: "pointer",
//     fontSize: "20px",
//   },
// };



// import React, { useEffect, useState } from "react";
// import { FaCheckCircle, FaTimesCircle, FaTrash } from "react-icons/fa";

// const GroupInfo = () => {
//   const [groupInfo, setGroupInfo] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const groupId = "Y2FwaV9ncm91cDo5MTg5MTkxNzE5ODU6MTIwMzYzNDA0NTQyMTcwODAy";

//   const payload = { groupId };

//   useEffect(() => {
//     const fetchGroupInfo = async () => {
//       try {
//         const response = await fetch(
//           "https://emedha.com/echatbot/enotifier/groups/getGroupInfo.php",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(payload),
//           }
//         );

//         const data = await response.json();
//         setGroupInfo(data);
//       } catch (error) {
//         console.error("Error:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchGroupInfo();
//   }, []);

//   // 🔴 REJECT USER FUNCTION
//   const handleReject = async (mobile) => {
//     try {
//       const response = await fetch(
//         "https://emedha.com/echatbot/enotifier/groups/removeUserFromGroup.php",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             groupId: groupId,
//             userMobile: mobile, // ← pass clicked user's mobile number
//           }),
//         }
//       );

//       const result = await response.json();
//       console.log("Reject API response:", result);

//       // ✅ IF SUCCESS → Remove from UI
//       setGroupInfo((prev) => ({
//         ...prev,
//         participants: prev.participants.filter((u) => u.wa_id !== mobile),
//       }));
//     } catch (error) {
//       console.error("Error Rejecting User:", error);
//     }
//   };

//   if (loading) return <p>Loading...</p>;
//   if (!groupInfo) return <p>No data found</p>;

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.title}>{groupInfo.subject}</h2>
//       <p style={styles.description}>{groupInfo.description}</p>

//       <h3 style={styles.subTitle}>Participants</h3>

//       {groupInfo.participants?.map((user, index) => (
//         <div key={index} style={styles.card}>
//           <span style={styles.number}>{user.wa_id}</span>

//           <div style={styles.iconRow}>
//             {/* <FaCheckCircle
//               style={styles.iconGreen}
//               title="Approve"
//             /> */}

//             <FaTimesCircle
//               style={styles.iconRed}
//               title="Reject"
//               onClick={() => handleReject(user.wa_id)}
//             />

//             {/* <FaTrash
//               style={styles.iconDelete}
//               title="Remove"
//             /> */}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default GroupInfo;


// const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "20px auto",
//     padding: "20px",
//     borderRadius: "14px",
//     background: "#fff",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//     fontFamily: "Poppins, sans-serif",
//   },
//   title: { color: "#0158a2", marginBottom: "6px" },
//   description: { color: "#444", marginBottom: "20px" },
//   subTitle: { color: "#222", marginBottom: "12px" },
//   card: {
//     display: "flex",
//     justifyContent: "space-between",
//     background: "#f2f7ff",
//     padding: "12px 16px",
//     marginBottom: "10px",
//     borderRadius: "12px",
//     alignItems: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
//   },
//   number: { fontWeight: "600", fontSize: "16px" },
//   iconRow: { display: "flex", gap: "14px" },
//   iconGreen: { color: "#2ecc71", cursor: "pointer", fontSize: "22px" },
//   iconRed: { color: "#e74c3c", cursor: "pointer", fontSize: "22px" },
//   iconDelete: { color: "#555", cursor: "pointer", fontSize: "20px" },
// };



import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaTimesCircle } from "react-icons/fa";

const GroupInfo = () => {
  const [allGroups, setAllGroups] = useState([]);          // ⭐ NEW: List of all groups
  const [selectedGroup, setSelectedGroup] = useState("");   // ⭐ NEW: Selected group
  const [groupInfo, setGroupInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  // ⭐ 1) FETCH ALL GROUPS
  // useEffect(() => {
  //   const fetchGroups = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
  //         {
  //           method: "GET",
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       );

  //       const data = await response.json();
  //       setAllGroups(data.data || []);
  //     } catch (error) {
  //       console.error("Error loading groups:", error);
  //     }
  //   };

  //   fetchGroups();
  // }, []);


    const [pid, setPid] = useState(null);
  
    useEffect(() => {
      const loggedUser = JSON.parse(sessionStorage.getItem("user"));
      if (!loggedUser) return;
  
      const emailToUse =
        loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
  
      axios
        .get(
          `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
            emailToUse
          )}`
        )
        .then((response) => {
          const userData = response.data;
          if (userData.p_id) {
            setPid(userData.p_id);
            fetchGroups(userData.p_id);
          }
        })
        .catch((err) => console.error("PID Load Error:", err));
    }, []);

// useEffect(() => {
   const fetchGroups = async (pidValue) => {
      try {
        const res = await axios.post(
          "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
          {
            pid: pidValue,
            limit: 50,
            after:  "",
            before: "",
          },
          { headers: { "Content-Type": "application/json" } }
        );
        
  console.log('this is res',res.data)
        setAllGroups(res.data.data || []);
      } catch (err) {
        console.error("Error fetching groups:", err);
      }
    };

  //       fetchGroups();
  // }, []);

  // ⭐ 2) FETCH GROUP INFO WHEN SELECTED
  const loadGroupInfo = async (groupId) => {
    if (!groupId) return;

    setLoading(true);

    try {
      const response = await fetch(
        "https://emedha.com/echatbot/enotifier/groups/getGroupInfo.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ groupId }),
        }
      );

      const data = await response.json();
      setGroupInfo(data);
    } catch (error) {
      console.error("Error fetching group info:", error);
    } finally {
      setLoading(false);
    }
  };

  // ⭐ 3) REMOVE USER FROM GROUP
  const handleReject = async (mobile) => {
    try {
      await fetch(
        "https://emedha.com/echatbot/enotifier/groups/removeUserFromGroup.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            groupId: selectedGroup,
            userMobile: mobile,
          }),
        }
      );

      // Update UI
      setGroupInfo((prev) => ({
        ...prev,
        participants: prev.participants.filter((u) => u.wa_id !== mobile),
      }));
    } catch (error) {
      console.error("Error Rejecting User:", error);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Group Information</h2>

      {/* ⭐ GROUP DROPDOWN */}
      <select
        style={styles.dropdown}
        value={selectedGroup}
        onChange={(e) => {
          setSelectedGroup(e.target.value);
          loadGroupInfo(e.target.value);
        }}
      >
        <option value="">Select Group</option>

        {allGroups.map((g, i) => (
          <option key={i} value={g.id}>
            {g.subject}
          </option>
        ))}
      </select>

      {/* Loader */}
      {loading && <p>Loading group info...</p>}

      {/* No group selected */}
      {!loading && !groupInfo && <p>Select a group to view details.</p>}

      {/* Group Details */}
      {groupInfo && (
        <>
          <h2 style={styles.title}>{groupInfo.subject}</h2>
          <p style={styles.description}>{groupInfo.description}</p>

          <h3 style={styles.subTitle}>Participants</h3>

          {groupInfo.participants?.map((user, index) => (
            <div key={index} style={styles.card}>
              <span style={styles.number}>{user.wa_id}</span>

              <div style={styles.iconRow}>
                <FaTimesCircle
                  style={styles.iconRed}
                  title="Reject"
                  onClick={() => handleReject(user.wa_id)}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default GroupInfo;

// -------------------- STYLES --------------------
const styles = {
  container: {
    width: "90%",
    maxWidth: "600px",
    margin: "20px auto",
    padding: "20px",
    borderRadius: "14px",
    background: "#fff",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    fontFamily: "Poppins, sans-serif",
  },
  title: { color: "#0158a2", marginBottom: "6px" },
  dropdown: {
    width: "100%",
    padding: "10px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    marginBottom: "15px",
    fontSize: "15px",
  },
  description: { color: "#444", marginBottom: "20px" },
  subTitle: { color: "#222", marginBottom: "12px" },
  card: {
    display: "flex",
    justifyContent: "space-between",
    background: "#f2f7ff",
    padding: "12px 16px",
    marginBottom: "10px",
    borderRadius: "12px",
    alignItems: "center",
    boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
  },
  number: { fontWeight: "600", fontSize: "16px" },
  iconRow: { display: "flex", gap: "14px" },
  iconRed: { color: "#e74c3c", cursor: "pointer", fontSize: "22px" },
};
